document.addEventListener('DOMContentLoaded', function() {
    // Select all job descriptions
    const jobDescriptions = document.querySelectorAll('.job-card-description');

    jobDescriptions.forEach(jobDescription => {
        // Select all job descriptions items
        const descriptions = jobDescription.querySelectorAll('.job-card-contract-item-description');

        // Find the max height of the descriptions, to prevent the job-card-description from resizing
        let maxHeight = 0;
        descriptions.forEach(description => {
            if (description.scrollHeight > maxHeight) {
                maxHeight = description.scrollHeight;
            }
        });

        // Define the min-height of the job-card-description
        jobDescription.style.minHeight = maxHeight + 'px';
    });

    // Select job cards to manage the contract toggle buttons and descriptions separately
    const jobCards = document.querySelectorAll('.job-card');

    jobCards.forEach(jobCard => {
        // Select all contract toggle buttons and descriptions
        const toggleButtons = jobCard.querySelectorAll('.contract-toggle');
        const descriptions = jobCard.querySelectorAll('.job-card-contract-item-description');

        // First button and description are active by default
        toggleButtons[0].classList.add('active');
        descriptions[0].style.display = 'block';

        toggleButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Remove the 'active' class from all buttons and hide all descriptions
                toggleButtons.forEach(btn => btn.classList.remove('active'));
                descriptions.forEach(description => description.style.display = 'none');

                // Add the 'active' class to the clicked button and show the target description
                this.classList.add('active');
                const targetId = this.dataset.target;
                const targetDescription = jobCard.querySelector(`#${targetId}`);
                
                if (targetDescription) {
                    targetDescription.style.display = 'block';
                }
            });
        });
    });
});
